import { Typography } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledProductTitle = styled(Link)`
    width: 85%;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    text-align: left;
    color: ${(props) => props.theme.primaryTypographyColor};
`;

export const StyledProductPrice = styled(Typography)<{
    $isPersonal?: boolean;
    $isOld?: boolean;
}>`
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: right;
    white-space: nowrap;

    color: ${({ $isOld, $isPersonal, theme }) => {
        if ($isOld) return theme.disabledTypographyColor;
        if ($isPersonal) return theme.colors.warning;
        return theme.additionalTypographyColor;
    }};

    text-decoration: ${({ $isOld }) => ($isOld ? "line-through" : "none")};
`;
